// Mensagem para o toast de erro de uma chamada à API: um 422 traz o motivo em
// erros[0].mensagem (a `mensagem` do envelope é só "dados inválidos"); os demais erros
// trazem em `mensagem`. Sem resposta (rede), undefined — o toast mostra só o título.
export function apiErrorMessage(error) {
  const data = error?.response?.data;
  return data?.erros?.[0]?.mensagem ?? data?.mensagem;
}
